import { Component, effect, Inject, inject } from '@angular/core';

import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  InputFieldComponent,
  ThemeButton,
} from '../../../../../../component-library/dist';
import { AccessHashService } from '../../../services/access-hash.service';
import { GermanDateDirective } from '../../../shared/date.directive';
import { ErrorHandlerService } from '../../../shared/error-handler.service';
import { FormDirective } from '../../../shared/form-directive.directive';
import { RouterService } from '../../../shared/router.service';

@Component({
  selector: 'app-birthday-dialog',
  standalone: true,
  imports: [
    CommonModule,
    InputFieldComponent,
    ThemeButton,
    ReactiveFormsModule,
    FormDirective,
    GermanDateDirective,
  ],
  templateUrl: './birthday-dialog.component.html',
  styleUrl: './birthday-dialog.component.scss',
})
export class BirthdayDialogComponent {
  private dialogRef = inject(MatDialogRef<BirthdayDialogComponent>);
  title = '';
  message = '';
  error = false;
  isLoading = false;
  protected onSubmit: (value: string | undefined) => void = () => {};
  public form = new FormGroup({
    birthday: new FormControl('', [Validators.required]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected accessHashService: AccessHashService,
    protected routerService: RouterService,
    public errorHandler: ErrorHandlerService,
  ) {
    effect(() => {
      this.onSubmit = this.data.onSubmit();
      this.title = this.data.title();
      this.message = this.data.message();
      this.error = this.data.isError();
      this.isLoading = this.data.isLoading();
    });
  }

  public async handleSubmit() {
    this.onSubmit(this.form.getRawValue().birthday ?? undefined);
  }

  public handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleSubmit();
    }
  }
}
